import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAuth } from '@/auth/AuthContext';
import { UnifiedIcon } from '@/components/UnifiedIcon';
import { ThemeToggle } from '@/designSystem/atoms/ThemeToggle';
import { PageWithFooter } from '@/designSystem/organisms/PageWithFooter';

/**
 * MFA second step placeholder until coolture_auth ships TOTP (feature-flagged).
 */
export function MfaPage() {
  const navigate = useNavigate();
  const { completeMfaStub, logout } = useAuth();

  const handleContinueStub = useCallback(() => {
    completeMfaStub();
    navigate('/home', { replace: true });
  }, [completeMfaStub, navigate]);

  const handleCancel = useCallback(async () => {
    await logout();
    navigate('/login', { replace: true });
  }, [logout, navigate]);

  return (
    <PageWithFooter
      data-testid="agents-login-mfa"
      mainClassName="relative flex flex-1 flex-col items-center justify-center px-4 py-12"
    >
      <div className="absolute right-4 top-4 md:right-8 md:top-6">
        <ThemeToggle />
      </div>

      <section className="ds-surface w-full max-w-md rounded-kc p-8">
        <header className="mb-6 text-center">
          <UnifiedIcon name="ShieldCheck" size={36} className="mx-auto text-kincode" />
          <h1 className="mt-3 text-xl font-semibold text-primary">Verify your identity</h1>
          <p className="mt-2 text-sm text-secondary">
            MFA UI stub — wire to auth when TOTP is available.
          </p>
        </header>
        <button
          type="button"
          data-testid="agents-login-mfa-continue-stub"
          onClick={handleContinueStub}
          className="ds-button-primary mb-3 w-full"
        >
          Continue (dev stub)
        </button>
        <button
          type="button"
          data-testid="agents-login-mfa-cancel"
          onClick={() => {
            void handleCancel();
          }}
          className="w-full rounded-lg border border-default bg-surface py-2.5 text-sm text-secondary transition-colors hover:bg-subtle"
        >
          Back to login
        </button>
      </section>
    </PageWithFooter>
  );
}
